import { observer } from 'mobx-react-lite';
import { TObjectInspection, useValidableContext, Validable } from '..';
import { ChangeEvent, ReactNode } from 'react';

export type ValidableFieldProps<T extends object> = {
  className?: string;
  context: Validable<T>;
  label?: string;
  onChange?: (
    value: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
  path: TObjectInspection<T>;
  title?: string;
};

export function makeValidableField<
  AdditionalProps extends Record<string, any> = Record<string, any>,
>(
  Component: (
    props: ValidableFieldProps<{ name: string }> & AdditionalProps,
  ) => ReactNode,
) {
  const ActualComponent = observer(Component);

  const NewValidableField = <T extends object>(
    props: ValidableFieldProps<T> & AdditionalProps,
  ) => {
    const reactContext = useValidableContext<T>();
    const actualContext = props.context ?? reactContext;

    if (!actualContext) throw new Error('ValidableContext not found');

    return <ActualComponent {...(props as any)} context={actualContext} />;
  };

  return NewValidableField;
}
